<template>
  <div class="flex flex-wrap gap-4">
    <ContactCard v-for="card in cards" :key="card.sys.id" :content="card" />
  </div>
</template>

<script setup lang="ts">
import type { ContactCards } from '@/types/contentful';

type Props = {
  content: ContactCards;
};

const props = defineProps<Props>();

const cards = computed(() => props.content.fields?.contactCards || []);
</script>

<script lang="ts">
export default defineComponent({
  name: 'ContactCards',
});
</script>
